import { ReactElement, ReactNode, forwardRef } from 'react';
import { handleBtnClassname } from './style.css';
import { Button } from '@ff-it/ui';
export { handleBtnClassname };

type DragHandleProps = {
  testId?: string;
  disabled?: boolean;
  active?: boolean;
  children?: ReactNode;
};

export const DragHandle = forwardRef<HTMLButtonElement, DragHandleProps>(function DragHandle(
  { testId, children, active, ...props },
  ref,
): ReactElement {
  return (
    <Button icon="grip-vertical" variant="ghost" className={handleBtnClassname} {...props} ref={ref}>
      {children}
    </Button>
  );
});
